<template>
  <div>
    <el-button style="margin-bottom: 10px" type="primary" icon="el-icon-plus"
      @click="openEditVersionMailDialog(true)">新建</el-button>
    <el-table :data="mailList" border size="small" style="width: 1091px">
      <el-table-column prop="version" align="center" width="100" show-overflow-tooltip>
        <template slot="header">
          <span>目标版本</span>
          <div>
            <el-tooltip effect="dark" placement="top">
              <div slot="content">
                玩家的客户端版本达到目标版本时就会获得对应的邮件
              </div>
              <span><i class="el-icon-question" style="font-size: 1.2em"></i></span>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>

      <el-table-column align="center" width="160" show-overflow-tooltip>
        <template slot="header">
          <span>新玩家也能获得本邮件</span>
          <div>
            <el-tooltip effect="dark" placement="top">
              <div slot="content">
                这里的新玩家针对的是出生时所用的客户端版本恰好是目标版本
              </div>
              <span><i class="el-icon-question" style="font-size: 1.2em"></i></span>
            </el-tooltip>
          </div>
        </template>
        <template slot-scope="scope">
          <span>{{ scope.row.canNewPlayerGet ? "是" : "否" }}</span>
        </template>
      </el-table-column>

      <el-table-column label="标题和正文" align="center" width="100">
        <template slot-scope="scope">
          <el-popover v-model="scope.row.isTitleAndContentEverBeingViewed" placement="right" trigger="click"
            width="600">
            <div v-if="scope.row.isTitleAndContentEverBeingViewed">
              <MailTemplate :languageTemplates="scope.row.languageTemplates" readonly></MailTemplate>
            </div>
            <span slot="reference" class="link-button"><i class="el-icon-view" style="margin-right: 3px"></i>查看</span>
          </el-popover>
        </template>
      </el-table-column>

      <el-table-column label="附件" align="center" width="330" show-overflow-tooltip>
        <template slot-scope="scope">
          <div v-for="(attachment, index) in JSON.parse(scope.row.props)" :key="index">
            {{ availableAttachmentsMappedById[attachment.id] }} x {{ attachment.num }}
          </div>
        </template>
      </el-table-column>

      <el-table-column prop="createdAt" label="创建时间" align="center" width="150" show-overflow-tooltip>
      </el-table-column>

      <el-table-column prop="creator" label="创建人" align="center" width="100" show-overflow-tooltip>
      </el-table-column>

      <el-table-column label="操作" align="center" width="150">
        <template slot-scope="scope">
          <span class="link-button" style="color: red" @click="onClickDeleteBtn(scope.row)">删除</span>
          <span class="link-button" @click="openEditVersionMailDialog(false, scope.row)">修改</span>
          <span class="link-button" @click="openEditVersionMailDialog(true, scope.row)">复制</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";
const dialogutil = require("@/dialogutil");

import MailTemplate from "@/pages/mail/components/MailTemplate";

export default {
  data() {
    return {
      mailList: [],
      availableAttachmentsMappedById: {},
    }
  },

  async created() {
    this.availableAttachmentsMappedById = await this.$bizutil.loadAttachments(false);
    this.loadMailList();
  },

  components: {
    MailTemplate,
  },

  methods: {
    async loadMailList() {
      this.mailList = [];

      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/admin/manageVersionMails`,
          {
            action: "list",
          },
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message.error(resData.message);
        return;
      }

      let listInResponse = resData.data.list.mails || [];

      let mailList = [];

      for (let m of listInResponse) {
        mailList.push({
          version: m.version,
          canNewPlayerGet: m.canNewPlayerGet,
          createdAt: util.ms2datetime(m.createdAt),
          creator: m.creator,
          languageTemplates: m.languageTemplates,
          props: m.props,
        })
      }

      this.mailList = mailList;
    },

    async deleteMail(version) {
      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/admin/manageVersionMails`,
          {
            action: "delete",
            delete: {
              version: version,
            }
          },
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message.error(resData.message);
        return;
      }

      for (let i = 0; i < this.mailList.length; i++) {
        if (this.mailList[i].version == version) {
          this.mailList.splice(i, 1);
          break;
        }
      }

      this.$message({
        message: "删除成功",
        type: "success",
      });
    },

    async onClickDeleteBtn(mail) {
      try {
        // 弹确认框
        await this.$confirm(`确认删除目标版本为“${mail.version}”的邮件？`);

        await this.deleteMail(mail.version);
      } catch (e) { }
    },

    /**
     * 打开版本邮件编辑框
     * @param isCreate 
     * @param existedData 
     */
    openEditVersionMailDialog(isCreate, existedData) {
      dialogutil.open("EditVersionMailDialog", {
        closedCallback: () => {
          this.loadMailList();
        },
        data: {
          isCreate: isCreate,
          existedData: existedData,
        }
      });
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-table__row td {
  padding: 3px 0;
}

::v-deep .el-table .cell {
  line-height: 18px;
}

.link-button {
  color: rgb(37, 148, 240);
  cursor: pointer;
  margin-left: 5px;
  margin-right: 5px;
}
</style>